import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pDynamicDialogHeader]',
  standalone: false,
})
export class DynamicDialogHeeader {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
